// Mapa oficial de migração de slugs legados → slugs canônicos publicados.
// Preserva links antigos, evita 404 e impede acesso a conteúdo v1.
// Nenhuma alteração editorial deve ocorrer aqui — apenas normalização de rota.
export const LEGACY_SLUG_MAP: Record<string, string> = {
  "passeador-de-caes": "passeador-de-caes-por-assinatura",
  "limpeza-de-estofados": "higienizacao-de-estofados",
};

export function resolveLegacySlug(slug: string): string | null {
  return LEGACY_SLUG_MAP[slug] ?? null;
}
